document.addEventListener('DOMContentLoaded', function() {
    // Check if the current URL contains '/collections/'
    if (window.location.pathname.includes('/collections/')) {
        // Extract the collection handle from the URL
        var pathArray = window.location.pathname.split('/');
        var collectionHandle = pathArray[pathArray.length - 1];
        
        // Add class to body tag based on the collection handle
        document.body.classList.add('collection-' + collectionHandle, 'cltn');

    }
});
